import React from "react";
import Grid from "@material-ui/core/Grid";
import MediaFilesCard from "../creator-application/dashboard/MediaFilesCard";
import RecentModulesCard from "../components/dashboard/RecentModulesCard";
import CollectionsCard from "../creator-application/dashboard/CollectionsCard";
import CspCard from "../creator-application/dashboard/CspCard";
import CspSubmissionsCard from "../creator-application/dashboard/CspSubmissionsCard";
import CreatorUsersCard from "../creator-application/dashboard/CreatorUsersCard";

const CreatorManagerDashboard = () => {
  return (
    <Grid container wrap="nowrap" spacing={5}>
      <Grid item>
        <Grid container spacing={5}>
          <Grid item md={12}>
            <Grid container spacing={5}>
              <Grid item sm={4}>
                <RecentModulesCard />
              </Grid>

              <Grid item sm={8}>
                <MediaFilesCard />
              </Grid>
            </Grid>
          </Grid>

          <Grid item md={12}>
            <CollectionsCard />
          </Grid>
        </Grid>
      </Grid>

      <Grid item md={4}>
        <Grid container spacing={5}>
          <Grid item>
            <Grid container spacing={5}>
              <Grid item>
                <CreatorUsersCard />
              </Grid>

              <Grid item>
                <CspCard />
              </Grid>
            </Grid>
          </Grid>

          <Grid item>
            <CspSubmissionsCard />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CreatorManagerDashboard;
